module.exports = __webpack_public_path__ + "static/media/account-cover.e7d5c08f.jpg";